// RepeatOptional nodes are used for `a?` regular expression syntax. It is not
// rendered directly; it just indicates that the [Repeat](./repeat.html) node
// loops zero or one times.

export default {
  minimum: 0,
  maximum: 1
};
